module.exports = __webpack_public_path__ + "static/media/Youtube_play_icon.d5829668.svg";